import React from 'react';

class Snackbar extends React.Component {
  render() {
    return (
      <div className="snackbar shadow-lg d-flex justify-content-between align-content-center align-items-center">
        <div className="snackbar-message">{this.props.message}</div>
        <div className="snackbar-actions d-flex justify-content-between align-content-center align-items-center">{this.props.children}</div>
      </div>
    );
  }
}

export default Snackbar;
